import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { HeaderBar } from "../Header";
import { Footer } from "../Footer";
import { useCookies } from 'react-cookie';
import { Box, Drawer, Grid, IconButton, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useRef, useState } from "react";
import { IoMdMenu, IoIosCloseCircleOutline } from "react-icons/io";
import { MedidasLayOut, themePalette } from "../../config/theme.config";
import { FaHome } from "react-icons/fa";
import { FaGooglePlay } from "react-icons/fa";
import { PiStudentFill } from "react-icons/pi";
import { GiArchiveResearch } from "react-icons/gi";
import { useIsAuthenticated } from "@azure/msal-react";
import { useAppSelector } from "../../redux/hooks";
export const LayoutAuth: React.FC<{}> = () => {
    const [cookie, setCookie, remove] = useCookies();
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    const [size, setSize] = useState(45);
    const [width, setWidth] = useState("10vw");
    const [topHam, setTopHam] = useState(20);
    const [leftHam, setLeftHam] = useState(10);
    const headerRef = useRef<HTMLDivElement>(null);
    const [headerHeight, setHeaderHeight] = useState(0);
    const navigate = useNavigate();
    const theme = useTheme();
    const isXLargeScreen = useMediaQuery(theme.breakpoints.up('xl'));
    const isLargeScreen = useMediaQuery(theme.breakpoints.between('lg', 'xl'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.between('md', 'lg'));
    const isSmallScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isXSmallScreen = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
    const isXSmallDownScreen = useMediaQuery(theme.breakpoints.down('xs'));

    //const isAuthenticated = useIsAuthenticated();

    const { isAuth, userData } = useAppSelector((state) => state.authReducer);

    //console.log(isAuthenticated);

    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    const GoTo = (site: string) => {
        navigate(site);
    };

    React.useEffect(() => {
        if (isXSmallScreen || isXSmallDownScreen) {
            setSize(25);
            setTopHam(9);
            setLeftHam(5);
            setWidth('20vw');
            setIsDrawerOpen(false);
            //console.log('xs');
        } else if (isSmallScreen) {
            setSize(30);
            setTopHam(20);
            setLeftHam(10);
            setWidth('10vw');
            setIsDrawerOpen(false);
            //console.log('sm');
        }
        else if (isMediumScreen) {
            setSize(30);
            setTopHam(20);
            setLeftHam(10);
            setWidth('7vw');
            //console.log('md');
        } else if (isLargeScreen) {
            setSize(35);
            setTopHam(20);
            setLeftHam(10);
            setWidth('5vw');
            //console.log('lg');
        } else if (isXLargeScreen) {
            setSize(35);
            setTopHam(20);
            setLeftHam(10);
            setWidth('5vw');
            // console.log('xl');
        } else {
            setSize(35);
            setTopHam(20);
            setLeftHam(10);
            setWidth(MedidasLayOut.WIDTH_SIDEBAR);
        }
    }, [isXSmallDownScreen, isXSmallScreen, isSmallScreen, isMediumScreen, isLargeScreen, isXLargeScreen]);

    React.useEffect(() => {
        if (headerRef.current) {
            //console.log(headerRef.current.clientHeight);
            if (isXSmallScreen || isXSmallDownScreen) {
                setHeaderHeight(headerRef.current.clientHeight / 9);
            } else if (isSmallScreen) {
                setHeaderHeight(headerRef.current.clientHeight / 9);
            } else if (isMediumScreen) {
                setHeaderHeight(headerRef.current.clientHeight / 9);
            } else if (isLargeScreen) {
                setHeaderHeight(headerRef.current.clientHeight / 9);
            } else if (isXLargeScreen) {
                setHeaderHeight(headerRef.current.clientHeight / 9);
            }
        }
    }, [isXSmallDownScreen, isXSmallScreen, isSmallScreen, isMediumScreen, isLargeScreen, isXLargeScreen, headerRef]);

    return (
        isAuth ?
            <Box sx={{ minHeight: '100vh' }}>
                <Box ref={headerRef} sx={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 1100 }}>
                    <HeaderBar />
                </Box>

                <Box  sx={{ display: 'flex', flex: 1, mt: 4,  overflow:"scroll" , scrollbarWidth:"none"}}>
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            mt: 5,
                            mb: 5,
                            width: 'auto',
                            ml: isDrawerOpen ? `${width}px` : '0',
                            transition: 'margin-left 0.3s',
                        }}
                    >
                        <Outlet />
                    </Box>
                </Box>
                <Footer />
            </Box>
            : <Navigate to='/' />
    );
};
